import { Col, Row } from 'antd';
import * as React from 'react';

import styled, { Theme } from '../../../../styled-components';

interface IProp {
    title: string
    content?: string
}

class WorkflowItemInfoComponent extends React.Component<IProp, {}> {

    render(): JSX.Element {

        return (
            <GoEpikWorkflowItem>
                <Row>
                    <Col sm={24} md={24} xl={24}>
                        <p className="goepik-text-gray">{this.props.title}</p>
                        <p>{this.props.content}</p>
                    </Col>
                </Row>
            </GoEpikWorkflowItem>
        );
    }
};

const GoEpikWorkflowItem = styled.div`
    margin-top: 10px;
    
    .goepik-text-gray{
        font-weight: 900;
        color: ${Theme.standard.lightGray3}!important;
    }
`;

export default WorkflowItemInfoComponent;
